import { CircularProgress, Grid } from "@material-ui/core";
import { observer } from "mobx-react";
import { useActiveProjectStore, useFeatureGuardian, useTemplates } from "@hooks";
import { LOCKED_FEATURES, TEMPLATE_TYPE } from "@utils";
import { TemplateCard } from "@components";
import { bool, func, number } from "prop-types";
import { BlankTemplateCard } from "@components/Templates/StaticTemplateCards/BlankTemplateCard";
import { XlsTemplateCard } from "@components/Templates/StaticTemplateCards/XlsTemplateCard";
import useStyle from "./TemplatesList.style";
import { checkTemplateCommentsQuery, getCompanyRateCardQuery } from "@query";

export const TemplatesList = observer(({
  defaultTemplateId,
  onSelect,
  showBlank = false,
  showXls = false,
  companyTemplates = false,
  ...templateCardProps
}) => {
  const creator = useActiveProjectStore();
  const classes = useStyle();

  const { checkAccess, FeatureAlert } = useFeatureGuardian(
    LOCKED_FEATURES.ESTIMATION
  );
  
  const {
    templates,
    isLoading,
  } = useTemplates();
  
  const setWorkTypes = async () => {
    
    let workTypes = creator.workTypes;
    if (!workTypes.length) {
      workTypes = await getCompanyRateCardQuery();
      creator.setWorkTypes(workTypes);
    }
  }

  const selectTemplate = async (templateId, templateUuid) => {
    const allowed = await checkAccess();
    if (!allowed) return;
    
    // await setWorkTypes();
    
    let template;
    if(templateUuid) {
      template = templates.find((x) => x.uuid === templateUuid);
      template.hasComments = checkTemplateCommentsQuery(templateUuid);
    }
    
    creator.setTemplate(template, companyTemplates);
    
    onSelect(templateId);
  };

  const selectBlank = async () => {
    creator.setTemplate(undefined);
    await setWorkTypes();
    onSelect(TEMPLATE_TYPE.BLANK);
  };

  const selectXls = () => {
    creator.setTemplate(undefined);
    onSelect(TEMPLATE_TYPE.XLS);
  };

  return (
    <Grid
      item
      container
      spacing={3}
      alignContent="flex-start"
      className="py-6"
    >
      <FeatureAlert />
      {showBlank && <BlankTemplateCard onSelect={selectBlank} />}
      {showXls && <XlsTemplateCard onSelect={selectXls} />}
      {templates.map(({ id, uuid, ...other }) => (
        <TemplateCard
          key={uuid}
          id={id}
          uuid={uuid}
          isDefault={defaultTemplateId === id}
          onSelect={selectTemplate}
          {...other}
          {...templateCardProps}
        />
      ))}
      {isLoading && (
        <CircularProgress
          aria-label="progress indicator"
          className={classes.progress}
        />
      )}
    </Grid>
  );
});

TemplatesList.propTypes = {
  onSelect: func.isRequired,
  defaultTemplateId: number,
  showBlank: bool,
  showXls: bool,
  allowEdition: bool,
  allowRemoval: bool,
  pickerActionButtons: bool,
  
  // onSetDefault: func,
  // onRemove: func,
  // onEdit: func,x
  // companyTemplates: bool,
  // projectTypes: arrayOf(shape({
  //   id: number.isRequired,
  //   name: string.isRequired,
  //   color: string.isRequired,
  //   font: string.isRequired,
  // })),
};
